import * as React from 'react';
import { useState } from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { withRouter } from 'src/node_modules/kts-platform-frame/routes';
import ModulesState from '../Modules.State';
import ModulesAction from '../Modules.Action';
import { Menu, Divider, Dropdown, Tooltip, Icon } from 'antd';
import { NodeEnvType } from 'kts-platform-frame/entry/constant';
import { mediaUrl } from 'kts-platform-frame/entry/configUtils';
import Icon2 from 'kts-platform-frame/display/components/Icon';
import PortalsComponent from 'src/display/components/PortalsComponent';
import DrapTip from './DragTip';
import Drop from 'src/display/components/Drop';
import Help from './UI.Help';
import AppSdk from 'kts-platform-frame/appSdk';
const css = require('./index.scss');
const dingIcon = require('./Icon/ding.svg');
const dragIcon = require('./Icon/drag.svg');
const defaultIcon = require('./Icon/default.svg');
const arrowDownIcon = require('./Icon/arrowDown.svg');
const arrowUpIcon = require('./Icon/arrowUp.svg');

/** Redux接口 */
interface IReduxStatePart {
    NODE_ENV?: NodeEnvType;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@withRouter
@connect((state: ReduxState): IReduxStatePart => ({
    NODE_ENV: state.env.NODE_ENV
}))
export default class UIMenu extends UIBasic<IProps, ModulesState> {
    timer = 0;
    leavetimer = 0;
    userType = AppSdk.instance && AppSdk.instance.user && AppSdk.instance.user.userInfo.userType;
    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            hoverItemKey: '',
            openKeys: [],
            clientX: 238,
            clientY: 0
        };
    }
    getMenus = () => {
        const { menuMode, appMenu, categoryMenu } = this.modulesState;
        if (menuMode === 1) {
            return appMenu;
        } else {
            return categoryMenu;
        }
    }
    openCategory = (key) => {
        const { openKeys } = this.state;
        const index = openKeys.indexOf(key);
        if (index === -1) {
            openKeys.push(key);
        } else {
            openKeys.splice(index, 1);
        }
        this.setState({
            openKeys: [...openKeys]
        });
        ModulesAction.setAppBoxVisible(false);
    }
    isExpand = (key) => {
        const { openKeys } = this.state;
        const index = openKeys.indexOf(key);
        return index !== -1;
    }
    menuItemEnter = (key, e?) => {
        if (this.timer === 0) {
            window.clearTimeout(this.leavetimer);
            this.leavetimer = 0;
            const d = e && e.currentTarget.getBoundingClientRect().top;
            this.timer = window.setTimeout(() => {
                this.setState({
                    hoverItemKey: key,
                    clientY: d || 0
                }, () => {

                });
                // if (e && e.currentTarget) {
                //     this.setState({
                //         clientY: e.currentTarget.getBoundingClientRect().top
                //     });
                // }
            }, 150);
        }

    }
    menuItemLeave = () => {
        if (this.leavetimer === 0) {
            window.clearTimeout(this.timer);
            this.timer = 0;
            this.leavetimer = window.setTimeout(() => {
                this.setState({
                    hoverItemKey: ''
                });
                this.setState({
                    clientY: 0
                });
            }, 150);
        }
    }
    menuEnter = (e) => {
        setTimeout(() => {
            if (!this.modulesState.isShowMenu) {
                this.modulesState.isShowMenu = true;
                this.setModulesState();
            }
        }, 100);
    }
    menuLeave = (e) => {
        setTimeout(() => {
            if (this.modulesState.isShowMenu) {
                this.modulesState.isShowMenu = false;
                this.setModulesState();
            }
        }, 300);
    }
    renderCategory = (category, drag?, drop?) => {
        const key = category.appCategoryName;
        const isExpand = this.isExpand(key);
        const { appMenu, runAppKeying, isShowMenu, forceShowMenu } = this.modulesState;
        const app = appMenu.find(item => item.appKey === runAppKeying);
        const menuStyle = () => {
            if (isShowMenu || forceShowMenu) {
                if (this.state.hoverItemKey === key) {
                    return css.menuItemHover;
                }
                if (!isExpand) {
                    if (app && app.appCategoryName === key) {
                        return css.menuItemActive;
                    }
                }
            }
            return css.menuItem;
        };
        return (
            <div
                ref={drop}
                className={menuStyle()}
                key={key}
                onMouseEnter={() => this.menuItemEnter(key)}
                onMouseLeave={() => this.menuItemLeave()}
                onClick={() => this.openCategory(key)}
                style={{ cursor: 'revert' }}
            >
                <Icon2
                    className={(!isExpand && app && app.appCategoryName === key) ? css.activeIcon : css.menuIcon}
                    width={20}
                    height={20}
                    color={'#000000'}
                    src={category.appCategoryIcon ? `${mediaUrl()}${category.appCategoryIcon}` : defaultIcon}
                />
                {
                    isShowMenu || forceShowMenu ?
                        <>
                            <div
                                className={css.menuTextBox}
                            >
                                <div className={css.menuText}><Tooltip title={key} getPopupContainer={triggerNode => document.getElementById('dropMenus')} mouseLeaveDelay={0}>{key}</Tooltip></div>
                            </div>
                            <div className={css.actions}>
                                <DrapTip drag={drag} title="拖拽"><span><Icon2 src={dragIcon} className={css.drag} /></span></DrapTip>
                                <span>{isExpand ? <Icon2 src={arrowUpIcon} className={css.arrow} key="up" /> : <Icon2 src={arrowDownIcon} className={css.arrow} key="down" />}</span>
                            </div>

                        </>
                        : ''
                }
            </div>
        );
    }
    offsetclientY = () => {
        const dom = document.querySelector('.menuChildren') as HTMLDivElement;
        const clientHeight = document.body.clientHeight;
        const divHeight = dom.clientHeight;
        const offsetTop = dom.offsetTop;
        if (clientHeight - offsetTop < divHeight) {
            this.setState({
                clientY: clientHeight - divHeight
            });
        }
    }
    renderApp = (item, category, drag?) => {
        const { menuMode, runAppKeying, isShowMenu, forceShowMenu, appBoxShow } = this.modulesState;
        const isShow = isShowMenu || forceShowMenu;
        const appStyles = {};
        const textStyle = {};
        // 当前是否属于分类 并且打开情况
        if (menuMode === 2 && category) {
            if (isShow) {
                appStyles['paddingLeft'] = '10px';
            }
            textStyle['width'] = '130px';
            const categoryKey = category.appCategoryName;
            const isExpand = this.isExpand(categoryKey);
            if (!isExpand) {
                appStyles['display'] = 'none';
            }
        }

        const menuStyle = () => {
            if (isShow) {
                if (this.state.hoverItemKey === item.appKey) {
                    return css.menuItemHover;
                }
                if (runAppKeying === item.appKey || (appBoxShow && item.appKey === 'myAppBox')) {
                    return css.menuItemActive;
                }
            }
            return css.menuItem;
        };
        return (
            <div
                className={menuStyle()}
                key={item.appKey}
                onMouseEnter={(e) => this.menuItemEnter(item.appKey, e)}
                onMouseLeave={() => this.menuItemLeave()}
                onClick={(e) => this.onClickMenuHandlerNew(e, item.appKey)}
                style={appStyles}
            >
                <Icon2
                    className={
                        (runAppKeying === item.appKey || (appBoxShow && item.appKey === 'myAppBox')) ?
                            css.activeIcon : css.menuIcon
                    }
                    width={20}
                    height={20}
                    color={'#000000'}
                    src={item.appIcon ? `${mediaUrl()}${item.appIcon}` :
                        item.localIconUrl ?
                            item.localIconUrl : defaultIcon
                    }
                />
                {
                    isShow ?
                        <>
                            <div
                                className={css.menuTextBox}
                            >
                                <div className={css.menuText} style={textStyle}><Tooltip title={item.appName} getPopupContainer={triggerNode => document.getElementById('dropMenus')} mouseLeaveDelay={0}>{item.appName}</Tooltip></div>
                                {
                                    isShow && this.state.hoverItemKey === item.appKey && item.submenuList && item.submenuList.length ?
                                        <PortalsComponent el={document.getElementById('root')} offsetclientY={this.offsetclientY}>
                                            <div
                                                className={'menuChildren'}
                                                style={{ left: `${this.state.clientX}px`, top: `${this.state.clientY - 9}px` }}
                                                onMouseEnter={() => this.menuItemEnter(item.appKey)}
                                            >
                                                {
                                                    item.submenuList.map((v, i) => {
                                                        return (
                                                            <div
                                                                key={i}
                                                                className={css.menuChildrenText}
                                                                onClick={(e) => this.onClickMenuHandlerNew(e, item.appKey, v.submenuRoute)}
                                                            >
                                                                {v.submenuName}
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </PortalsComponent> : ''
                                }
                            </div>
                            {item.hasOwnProperty('instanceId') &&
                                <div className={css.actions}>
                                    <Tooltip title="取消常用" getPopupContainer={triggerNode => document.getElementById('dropMenus')} mouseLeaveDelay={0}><span onClick={(e) => { e.stopPropagation(); ModulesAction.cancelPopular(item); }}><Icon2 src={dingIcon} className={css.ding} /></span></Tooltip>
                                    <DrapTip drag={drag} title="拖拽"><span><Icon2 src={dragIcon} className={css.drag} /></span></DrapTip>
                                </div>
                            }
                        </> : ''
                }
            </div>
        );

    }
    onGuide = () => {
        this.props.history.push('/gettingStarted');
        // this.props.history.push(`/workbench/m/Kingxunlian.Initialize`);
    }
    render() {
        const { isShowMenu, forceShowMenu, menuMode } = this.modulesState;
        const isShow = isShowMenu || forceShowMenu;
        const optionMenu = [
            {
                appKey: 'Kingxunlian.NewsFeed',
                localIconUrl: require('./Icon/img.newsFeed.svg'),
                appName: '迅息'
            },
            {
                appKey: 'Kingxunlian.Network',
                localIconUrl: require('./Icon/img.network.svg'),
                appName: '网络'
            },
            {
                appKey: 'myAppBox',
                localIconUrl: require('./Icon/img.app.svg'),
                appName: '应用'
            }
        ];
        let appList: Array<any> = this.getMenus();
        return (
            <div
                className={`${(isShow) ? css.menu : css.hideMenu} ${(isShowMenu || forceShowMenu) ? css.showShadow : ''}`}
                onMouseEnter={(e) => this.menuEnter(e)}
                onMouseLeave={(e) => this.menuLeave(e)}
            >
                <div className={css.menuTop}>
                    {
                        optionMenu.map((item) => {
                            return this.renderApp(item, false);
                        })
                    }
                    <Divider style={{ margin: '10px auto 0px', width: '100%', minWidth: isShowMenu ? '100%' : 'auto' }} />
                </div>

                <div id="dropMenus" className={css.scrollMenu}>
                    {
                        appList && <Drop
                            type={'card'}
                            dataList={appList}
                            renderItem={(item, index, category, drag) => { return this.renderApp(item, category, drag); }}
                            renderMenu={(item, index, drag, drop) => { return this.renderCategory(item, drag, drop); }}
                            moveEnd={this.moveEnd}
                        />
                    }
                </div>
                {/* {this.userType === 'COMPANY_ADMIN' &&
                    <><Divider style={{ margin: '0', width: '100%', minWidth: isShowMenu ? '100%' : 'auto' }} />

                        <div style={{ paddingTop: 10, cursor: 'pointer' }} onClick={this.onGuide}>
                            {(isShowMenu || forceShowMenu) &&
                                <div style={{ padding: '0 8px', height: 40, display: 'flex', alignItems: 'center' }} className={css.menuHover}>
                                    <Icon2 style={{ marginLeft: 9, marginRight: 20, width: 20, height: 20 }} src={require('./Icon/add.svg')} width={20} height={20} />
                                    <div style={{ whiteSpace: 'nowrap' }}>快速设置</div>
                                </div>
                            }
                            {!isShowMenu && !forceShowMenu &&
                                <div style={{ display: 'flex', justifyContent: 'center' }} >
                                    <Icon2 style={{ fontSize: 20, width: 20 }} src={require('./Icon/add.svg')} width={20} height={20} />
                                </div>
                            }
                        </div>
                    </>
                } */}
                { isShow &&
                    <div className={css.bottom} onClick={() => { ModulesAction.toggleMode(); }}>
                        <span className={css.left} style={{ paddingLeft: 17, display: 'flex', alignItems: 'center' }}>
                            <Icon2 src={require('./Icon/qiehuan.svg')} width={20} height={20} style={{ fontSize: 20, width: 20 }} />
                            <span style={{ paddingLeft: 20, verticalAlign: 'middle', lineHeight: 1 }}>
                                {menuMode !== 2 && '切换到传统分类菜单'}
                                {menuMode === 2 && '切换到极简菜单'}
                            </span>
                        </span>
                        <span className={css.right} onClick={this.openHelp} style={{ paddingRight: 9 }}>
                            <Icon2 src={require('./Icon/help.svg')} width={20} height={20} style={{ fontSize: 20, width: 20 }} />
                        </span>
                    </div>
                }

                {this.modulesState.helpVisible && <Help />}
            </div>
        );
    }

    private moveEnd = (data: Array<any>, type?: string) => {
        //console.log('moveEnd',data);
        if (type === 'menu') {
            ModulesAction.resetAppMenu(data);
        } else {
            ModulesAction.setMenu(data);
        }
    }

    private openHelp = (e) => {
        e.stopPropagation();
        this.modulesState.helpVisible = true;
        this.setModulesState();
    }


    /** 点击了菜单 */
    private onClickMenuHandlerNew = (e, key, router?) => {
        e.stopPropagation();
        if (key === 'myAppBox') {
            this.modulesState.appBoxShow = !this.modulesState.appBoxShow;
            this.setModulesState();
        } else if (key === 'add') {
            ModulesAction.setAppBoxVisible(false);
            this.props.history.push(`/workbench/m/Kingxunlian.AppStore`);
        } else if (router) {
            ModulesAction.setAppBoxVisible(false);
            this.props.history.push(`/workbench/m/${key}/?routing=${router}`);
        } else {
            ModulesAction.setAppBoxVisible(false);
            this.props.history.push(`/workbench/m/${key}`);
        }
        this.menuLeave(e);
    }
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench2/UI.MenuNew/index.tsx